import { mergeConfig } from '@/config';
import Window from '@/ports-frontend/Window';

export async function initialiseConfig() {
  const assemblerContext = await Window.getAssemblerContext();
  mergeConfig(assemblerContext);
}
